import { useRouteError, useNavigate } from 'react-router-dom';
import React from 'react';
import errorimg from './error-page-img.png';
import styles from './index.scss';

interface RouteError {
  statusText: number;
  status: number;
  data: string;
}
type RouteErrorOrNull = RouteError | null;
interface IErrorProps {}
const PageErrorBoundary: React.FC<IErrorProps> = () => {
  const navigate = useNavigate();
  const errorunknown = useRouteError();
  const errorData = errorunknown as RouteErrorOrNull;

  function backClick() {
    const len = history.length;
    navigate('/index');
    // if (len > 1) {
    //   navigate(-1);
    // } else {
    //   document.location = 'phx://command=closeview';
    // }
  }
  if (errorData) {
    return (
      <div className={styles['wrap']}>
        <div className={styles['content']}>
          <img src={errorimg} className={styles['error-img']} />
          <p className={styles['error-text']}>
            错误页面
            <span className={styles['back-btn']} onClick={backClick}>
              回到首页
            </span>
          </p>
        </div>
      </div>
    );
  }
  return null;
};
export default PageErrorBoundary;
